import React from 'react';
import { useRouter } from 'next/router';
import { Button, FormikField, DatePicker } from '@feast-it/ui/light';
import { Form, Formik } from 'formik';
import * as Yup from 'yup/lib';

import { trackEvent } from '../../../modules/analytics';
import { GET_QUOTES_CLICKED } from '../../../constants/analytics';
import { formatDateNative } from '../../../modules/date';
import { stringifyURL } from '../../../modules/formatting';

import { PATHS } from '../../../constants/paths';
import { getAbsoluteUrl } from '@/helpers/formatUrl';
import { StyledInput } from './EventDatePickerV2.styled';

interface EventDatePickerV2Props {
  eventType: any;
  isMobile: boolean;
}

const initialValues = {
  date: '',
};

const createSchema = Yup.object().shape({
  date: Yup.date('Invalid date'),
});

export function EventDatePickerV2({
  eventType,
  isMobile,
}: EventDatePickerV2Props) {
  const router = useRouter();
  const handleSubmit = ({ date }) => {
    const query: { date?: any } = {};

    if (date) {
      query.date = formatDateNative(date);
    }
    const url = stringifyURL(PATHS.enquiryForm, query);

    trackEvent(GET_QUOTES_CLICKED, {
      source: 'hero',
      currentPage: getAbsoluteUrl(router.asPath),
      destinationUrl: getAbsoluteUrl(url),
    });

    window.location.href = url;
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={createSchema}
      onSubmit={handleSubmit}
    >
      <Form>
        <FormikField
          name="date"
          render={props => (
            <DatePicker
              {...props}
              dateFormat="do MMMM yyyy"
              min={new Date()}
              placeholder={`When is your ${eventType.toLowerCase()}?`}
              customInput={<StyledInput name="date" />}
            />
          )}
        />

        <Button
          dataTestId="get-quotes-hero-button"
          type="submit"
          color="paleYellow"
          variant="solid"
          size="large"
          isFullWidth={isMobile}
        >
          Get quotes
        </Button>
      </Form>
    </Formik>
  );
}
